var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneyShield = function SvgMoneyShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#money-shield_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEBEE",
    d: "M22.943 37.761c7.128 0 12.907-5.778 12.907-12.906V10.8H10.037v14.054c0 7.128 5.778 12.906 12.906 12.906"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B3552",
    strokeWidth: 1.66,
    d: "M30.616 19.418c0 6.677-5.412 12.09-12.089 12.09S6.438 26.094 6.438 19.417V6.182h24.178z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E5B",
    d: "M12.907 27.722c7.128 0 12.906-5.778 12.906-12.907V.762H0v14.054c0 7.128 5.778 12.906 12.907 12.906"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.839 13.617h3.488v-2.05H10.84v-1.17c0-1.366.845-2.211 2.122-2.211 1.079 0 1.834.575 2.05 1.582h2.391C17.132 7.52 15.424 6.1 12.961 6.1c-2.68 0-4.478 1.69-4.478 4.298v1.168H7.422v2.05h1.06v2.878h-1.06v2.05h9.747v-2.05h-6.33z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "money-shield_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .76h35.85v37H0z"
  })))));
};
export { SvgMoneyShield as ReactComponent };
export default __webpack_public_path__ + "images/money-shield.svg";